/* src/app/admin-dashboard/site-system/site-system.component.css */
mat-grid-tile {
  cursor: pointer;
  color: black;
  font-size: 15px;
}
mat-grid-tile:hover {
  background: #a4a3a4;
  color: white;
  font-size: 18px;
}
mat-grid-tile-footer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.button-spacer {
  margin-right: 8px;
}
.example-form {
  min-width: 150px;
  max-width: 500px;
  width: 100%;
}
.example-full-width {
  width: 100%;
}
.cab-button {
  display: inline-block;
  padding-left: 5px;
  padding-right: 5px;
  font-size: 9pt;
  color: white;
  cursor: pointer;
}
.cabinet {
  display: inline-block;
  background-color: black;
  padding-bottom: 10px;
  margin: 15px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}
.locker {
  border: 3px solid transparent;
  position: relative;
  display: block;
  background-color: #555555;
  width: 100px;
  height: 40px;
  margin: 5px;
  color: white;
  font-size: 8pt;
  border-radius: 5px;
}
.locker p {
  text-transform: capitalize;
  font-family: "Open Sans Light";
}
.locker-checkbox {
  position: absolute;
  top: 18px;
  left: 8px;
}
.CHARGED {
  background-color: #4CAF50;
}
.CHARGING {
  background-color: #008CBA;
  animation-name: blink-charging;
  animation-duration: 5s;
  animation-iteration-count: infinite;
}
@keyframes blink-charging {
  0% {
    background-color: #008CBA;
  }
  50% {
    background-color: rgb(0, 66, 84);
  }
  100% {
    background-color: #008CBA;
  }
}
.EMPTY {
  background-color: #555555;
}
.ERROR {
  background-color: #f44336;
  animation-name: blink-error;
  animation-duration: 2s;
  animation-iteration-count: infinite;
}
@keyframes blink-error {
  0% {
    background-color: #f44336;
  }
  50% {
    background-color: #833f3a;
  }
  100% {
    background-color: #f44336;
  }
}
.margin-hack {
  margin-top: -20%;
}
.select-menu {
  padding: 30px;
}
.locker-compid {
  font-family: "Open Sans Light";
  background-color: black;
  position: absolute;
  padding-top: 1px;
  padding-bottom: 1px;
  padding-right: 3px;
  padding-left: 3px;
  border-radius: 3px;
  top: 2px;
  left: 2px;
}
.locker-state {
  font-family: "Open Sans Light";
  font-size: 9pt;
  position: absolute;
  text-transform: capitalize;
  padding-left: 2px;
  padding-right: 2px;
  border-top-left-radius: 4px;
  top: 2px;
  left: 23px;
}
.selected {
  border-color: orange;
}
.active {
  border-color: green;
}
.unavailable {
  background: darkred;
}
.available {
  cursor: pointer;
}
.icon {
  cursor: pointer;
}
.smal {
  padding-top: 5px;
  font-size: 9pt;
}
/*# sourceMappingURL=site-system.component.css.map */
